export const ROUTE_PATHS = {
  HOME: "/",
  SERVICES: "/servicios",
  AGENTS: "/agentes-ia",
  CONTACT: "/contacto",
} as const;

export interface Service {
  id: string;
  title: string;
  description: string;
  iconName: string;
  longDescription?: string;
  features: string[];
  category: "AI" | "Automation" | "Data" | "CRM";
}

export interface CaseStudy {
  id: string;
  title: string;
  client: string;
  industry: string;
  description: string;
  results: {
    metric: string;
    value: string;
  }[];
  imageUrl: string;
  tags: string[];
}

export interface TeamMember {
  id: string;
  name: string;
  role: string;
  bio: string;
  imageUrl: string;
  socials?: {
    linkedin?: string;
    twitter?: string;
  };
}

export interface Stat {
  label: string;
  value: string;
  suffix?: string;
}

export function cn(...inputs: (string | undefined | null | boolean | { [key: string]: any })[]) {
  return inputs.filter(Boolean).join(" ");
}
